import { render, staticRenderFns } from "./CropPriceStatistics.vue?vue&type=template&id=5ea85780&"
import script from "./CropPriceStatistics.vue?vue&type=script&lang=js&"
export * from "./CropPriceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports